import { generateFormItem } from '../../../components/FormTpl/index'

const calcWidth = (options) => {
  if (options.cellWidth) {
    const cellWidth = options.cellWidth
    if (typeof cellWidth === 'string') {
      if (cellWidth === 'shorttext') {
        return 64
      }
      if (cellWidth === 'longtext') {
        return 200
      }
      if (cellWidth === 'datetime') {
        return 95
      }
    }
    return cellWidth || 'auto'
  }
  return 'auto'
}
const defaultRender = content => {
  if (Array.isArray(content)) {
    return content.length ? content.join(', ') : '/'
  }
  return content
}

export const generateTableColumn = function (self, h) {
  const tableChildren = self.tableSchema.map(cell => h('el-table-column', {
    props: {
      key: cell.key,
      prop: cell.key,
      label: self.$i18n(cell.label),
      width: calcWidth(cell.options || {}),
      className: cell.key
    },
    scopedSlots: {
      default: props => {
        if (cell.editable && self.inTableEditMode[props.row.id]) {
          return generateFormItem(h, cell, self.inTableEditData[props.row.id])
        } else {
          return h('span', {
            domProps: {
              innerHTML: cell.render ? cell.render.call(self, props.row[cell.key], props.row) : defaultRender(props.row[cell.key])
            }
          })
        }
      }
    },
  }))
  if (self.parsedActions && Array.isArray(self.parsedActions) && self.parsedActions.length) {
    tableChildren.push(h('el-table-column', {
      props: {
        label: self.$i18n('Action'),
      },
      scopedSlots: {
        default: props => {
          let actionNodes = []
          if (self.inTableEditMode[props.row.id]) {
            actionNodes = [
              h('el-button', {
                props: {
                  size: 'mini',
                  type: 'success'
                },
                on: {
                  click: () => {
                    self.$refs.form.validate(valid => {
                      if (!valid) {
                        self.$message({ type: 'error', message: self.$i18n('Form validate error !') })
                        return
                      }
                      self.$emit('triggerUpdate', {
                        data: {
                          ...self.inTableEditData[props.row.id],
                          id: props.row.id,
                          [self.tableSchema[0].key]: props.row.id
                        },
                        // TODO: move 'fetch' action to store
                        cb: () => self.onSearch()
                      })
                      self.inTableEditMode[props.row.id] = false
                    })
                  }
                }
              }, [self.$i18n('OK')]),
              h('el-button', {
                props: { size: 'mini' },
                on: { click: () => self.inTableEditMode[props.row.id] = false }
              }, [self.$i18n('Cancel')])
            ]
          } else {
            self.parsedActions.forEach(action => {
              if (action.hide) {
                if (typeof action.hide === 'boolean') {
                  return
                } else if (action.hide(props.row, self.$store.state)) {
                  return
                }
              }
              actionNodes.push(h('el-button', {
                props: { size: 'mini' },
                on: {
                  click: () => action.click.call(self, props.$index, props.row)
                }
              }, [self.$i18n(action.label)]))
            })
          }
          return actionNodes.length === 0 ? null : h('el-button-group', {}, actionNodes)
        }
      },
    }))
  }
  return tableChildren
}

export default function (self, h) {
  const tableChildren = generateTableColumn(self, h)
  return h('el-table', {
    props: {
      data: self.tableData.data,
      headerCellStyle: { background: '#f0f2f5' },
      style: {
        width: '100%'
      },
      border: true,
      stripe: true
    },
    on: {
      click: self.onSearch
    }
  }, tableChildren)
}



// WEBPACK FOOTER //
// ./packages/creator/common/vnode/table.js